export const UPDATE_CHECKBOX = "UPDATE_CHECKBOX";
export const UPDATE_ERROR = "UPDATE_ERROR";
export const UPDATE_CONTACT_ACCORDIAN = "UPDATE_CONTACT_ACCORDIAN";
export const UPDATE_ADDRESS_ACCORDIAN = "UPDATE_ADDRESS_ACCORDIAN";
export const UPDATE_PAYMENT_ACCORDIAN = "UPDATE_PAYMENT_ACCORDIAN";
